<template>
	<div>
		<!-- Bannière ameli -->
		<AmeliBanner />
		<HeaderBar
			:navigation-items="navigationItems()"
			:mini-version="isMobile()"
		>
			<template #brand-content>
				<span
					v-if="!isMobile()"
					class="text-subtitle-1 text-sm-h3"
					style="color: #DA847B"
				>
					Annuaire des radiologues agréés
				</span>
			</template>
			<template
				#navigation-bar-secondary-content
			>
				<div class="d-flex flex-grow-1 justify-end">
					<v-btn
						v-if="radiologistRedirectUrl !== ''"
						:href="radiologistRedirectUrl"
						class="font-weight-bold white--text"
						text
					>
						Radiologues
					</v-btn>
					<v-divider
						v-if="insuredRedirectUrl !== '' && insuredRedirectUrl !== ''"
						class="white my-2"
						dark
						vertical
					/>
					<v-btn
						v-if="insuredRedirectUrl !== ''"
						:href="insuredRedirectUrl"
						class="font-weight-bold white--text"
						text
					>
						Assurées
					</v-btn>
				</div>
			</template>
			<template
				#navigation-drawer-append
			>
				<div class="d-flex flex-column flex-grow-1 justify-end align-start">
					<v-btn
						v-if="radiologistRedirectUrl !== ''"
						:href="radiologistRedirectUrl"
						class="font-weight-bold white--text"
						text
					>
						Radiologues
					</v-btn>
					<v-btn
						v-if="insuredRedirectUrl !== ''"
						:href="insuredRedirectUrl"
						class="font-weight-bold white--text"
						text
					>
						Assurées
					</v-btn>
				</div>
			</template>
		</HeaderBar>
	</div>
</template>

<script setup lang="ts">
	import { getCurrentInstance } from 'vue';
	import { MAINTENANCE_ENABLED } from '@/constants';
	import { NavigationItem } from '@cnamts/vue-dot/src/patterns/HeaderBar/types';
	import AmeliBanner from './ameli-banner.vue';

	const radiologistRedirectUrl = window.URL_RADIOLOGIST;
	const insuredRedirectUrl = window.URL_INSURED;

	function navigationItems(): NavigationItem[] | null {
		if (MAINTENANCE_ENABLED) {
			return null;
		}

		return [
			{
				label: 'Annuaire',
				to: {
					name: 'search'
				}
			}
		];
	}

	/**
	 * Détermine si l'application est en vue mobile
	 */
	function isMobile(): boolean | undefined {
		return getCurrentInstance()?.proxy.$vuetify.breakpoint.smAndDown;
	}
</script>
